import { Component, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { AppConfigService } from '../../../app-config.service';
import { OFFRE_ACCEDANTS_URL_FR, OFFRE_ACCEDANTS_URL_EN } from '../../../../configs/urls.config';
import { GtmService } from '../../../shared/services/gtm.service';
import { GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES, GTM_PUSH_CATEGORY } from '../../../shared/modeles/variables';
import { DISPLAY_NO_IMAGE } from '../../directives/dynamicBackgroundImage/dynamic-background-image.directive';

@Component({
  selector: 'app-promo-banner',
  templateUrl: './promo-banner.component.html',
  styleUrls: ['./promo-banner.component.scss'],
  standalone: false
})
export class PromoBannerComponent implements OnInit {
  promoUrl: SafeUrl;

  constructor(private readonly _appConfigService: AppConfigService, private readonly _gtmService: GtmService) {}

  ngOnInit() {
    this.resolveUrl();
  }

  private resolveUrl() {
    const offreAccedantsUrl = this._appConfigService.langue === 'fr' ? OFFRE_ACCEDANTS_URL_FR : OFFRE_ACCEDANTS_URL_EN;
    if (this._appConfigService.configData.contexteEnvironnement.app) {
      this.promoUrl = 'smdesj://web?' + offreAccedantsUrl;
    } else {
      this.promoUrl = offreAccedantsUrl;
    }
  }

  pushCybermetrie() {
    this._gtmService.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: 'En savoir plus - Bandeau offre accédants',
      action: 'clic',
      value: 0,
      nonInteraction: false
    });
  }

  getBackgroundImageSource() {
    return {
      mobile: DISPLAY_NO_IMAGE,
      desktop: '/promo-banner/promo-desktop.jpg',
      tablette: '/promo-banner/promo-tablet.jpg'
    };
  }
}
